<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->

<div fxLayout="column" id="itemRecordContainer">
  <div id="recordImageContainer">
    <record-image
      [images]="record.signatureImage"
      [respectOriginalAspectRatio]="true"
      [disableLightBox]="true"
    ></record-image>
  </div>
  <record-icon-text
    *ngIf="record.signatoryName"
    [text]="record.signatoryName"
    [icon]="faSignature"
  ></record-icon-text>
</div>
